module.exports = __webpack_public_path__ + "static/img/software10.850ec83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software10.jpg
// module id = 8lF0
// module chunks = 2